import { render, staticRenderFns } from "./Collaborator.vue?vue&type=template&id=1d296632"
import script from "./Collaborator.vue?vue&type=script&lang=js"
export * from "./Collaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports